var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuPerformanceOverviewReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22329",
    "data-name": "Group 22329",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.085,
    height: 14.313,
    viewBox: "0 0 16.085 14.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7461",
    "data-name": "Rectangle 7461",
    width: 16.085,
    height: 14.314,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22329-2",
    "data-name": "Group 22329",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13197",
    "data-name": "Path 13197",
    d: "M15.535,14.313H.55A.561.561,0,0,1,0,13.741V.571A.561.561,0,0,1,.55,0H15.535a.561.561,0,0,1,.55.572v13.17a.561.561,0,0,1-.55.572M6.761,4.242h7.387a.561.561,0,0,0,.55-.572V2a.561.561,0,0,0-.55-.572H6.761A.561.561,0,0,0,6.211,2V3.67a.561.561,0,0,0,.55.572m0,4.317h7.391a.561.561,0,0,0,.55-.572V6.317a.561.561,0,0,0-.55-.572H6.763a.561.561,0,0,0-.55.572V7.986a.561.561,0,0,0,.55.572m7.4,1.494H6.776a.561.561,0,0,0-.55.572V12.3a.561.561,0,0,0,.55.572h7.387a.561.561,0,0,0,.55-.572V10.624a.561.561,0,0,0-.55-.572m-9.38-6.36V2a.561.561,0,0,0-.55-.572H1.943A.561.561,0,0,0,1.393,2V3.693a.561.561,0,0,0,.55.572h2.29a.561.561,0,0,0,.55-.572M4.775,8V6.307a.561.561,0,0,0-.55-.572H1.935a.561.561,0,0,0-.55.572V8a.561.561,0,0,0,.55.572h2.29A.561.561,0,0,0,4.775,8M1.926,12.86H4.238a.561.561,0,0,0,.55-.572V10.62a.561.561,0,0,0-.55-.572H1.926a.561.561,0,0,0-.55.572v1.667a.561.561,0,0,0,.55.572",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuPerformanceOverviewReport);
export default __webpack_public_path__ + "static/media/Mainmenu-performance-overview-report.5822e27ac537bb9dd27be7ff643d5925.svg";
export { ForwardRef as ReactComponent };